import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './NotFoundPage.scss';

const cx = classNames.bind(styles);

const NotFoundPage = ({ type }) => {
  // console.log(type);
  return (
    <div
      className={type === 'web' ? cx('NotFoundPage') : cx('NotFoundPageMobile')}
    >
      <div className="center-box">
        <div className="err-img">
          <p className="page-notfound">Page Not Found</p>
        </div>

        <p className="err-message">
          찾을 수 없는 페이지입니다.
          <br />
          요청하신 페이지가 없거나, 잘못된 URL을 입력하셨어요 :)
        </p>
        <Link to="/">
          <button className="home-btn">홈으로 이동 ></button>
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
